import { render, staticRenderFns } from "./TimePlayed.vue?vue&type=template&id=c2b3f438&"
import script from "./TimePlayed.vue?vue&type=script&lang=js&"
export * from "./TimePlayed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports